import { defineStore, storeToRefs } from 'pinia'
import { useDYMainStore } from '~~/modules/nuxt3-module-doyac/stores/main'

export const useIGMainStore = defineStore('nuxt3-module-ingang-main', () => {
  const store = useDYMainStore()
  const refs = storeToRefs(store)
  return {
    ...refs,
    getShortCut: store.getShortCut
  }
})